"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "#004864"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.4,11.18a2,2,0,0,0,.08-.26,1.75,1.75,0,0,0,0-.56,2,2,0,0,0-.08-.26,1.39,1.39,0,0,0-.32-.48L9.84,5.36l-.3-.3a1.3,1.3,0,0,0-.23-.18,1.39,1.39,0,0,0-.79-.24,1.43,1.43,0,0,0-.79.24L7.56,5l-.06,0a1.47,1.47,0,0,0-.31,1.57,1.57,1.57,0,0,0,.31.48L8.94,8.55l.65.65H1.44a1.44,1.44,0,0,0,0,2.88H9.59L7.5,14.18a1.42,1.42,0,0,0-.31.47,1.47,1.47,0,0,0,.31,1.57,1.81,1.81,0,0,0,.23.18,1.43,1.43,0,0,0,.79.24h0a1.43,1.43,0,0,0,.5-.09,1.48,1.48,0,0,0,.45-.28l.07-.05,2.29-2.3,2.25-2.26A1.39,1.39,0,0,0,14.4,11.18Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.42,1.18H5.59A.51.51,0,0,0,5,1.76V8.29h2.4l-.55-.55A2.35,2.35,0,0,1,6.35,5.2a2.51,2.51,0,0,1,.51-.78L7,4.33c.09-.07.17-.15.26-.21a2.38,2.38,0,0,1,2.58,0,1.85,1.85,0,0,1,.37.31l.3.29L14.72,9a2.27,2.27,0,0,1,.52.78,2.13,2.13,0,0,1,.13.43,2.27,2.27,0,0,1,0,.9,2.13,2.13,0,0,1-.13.43,2.27,2.27,0,0,1-.52.78l-2.25,2.26-2.29,2.3-.1.09a2.5,2.5,0,0,1-.73.44,2.29,2.29,0,0,1-2.12-.23,3.47,3.47,0,0,1-.37-.3,2.51,2.51,0,0,1-.51-.78,2.35,2.35,0,0,1,.51-2.54L7.41,13H5v6.6a.51.51,0,0,0,.58.58h5.84l2.92,2.88a.28.28,0,0,0,.15.06.23.23,0,0,0,.15-.06l2.93-2.88h5.84a.51.51,0,0,0,.58-.58V1.76A.51.51,0,0,0,23.42,1.18Z"
  }));
};

exports["default"] = _default;